import http from 'hub-http/clients/apiClient';
import { getUrl } from '../utils/urlUtils';
export const setGroupKey = (groupKey, options) => {
  const taskGroupPath = 'usercontext/v1/onboarding/tasks/group';
  return http.post(getUrl(taskGroupPath, options), {
    data: {
      groupKey
    }
  });
};